import { useContext, useMemo } from 'react';

import { StickyContext, StickyContextValue } from './StickyContext.js';

export type StickyProviderProps = Omit<StickyContextValue, 'parent'> & {
  children?: React.ReactNode;
};

export const StickyProvider: React.FC<StickyProviderProps> = ({ id, container, children }) => {
  const parent = useContext(StickyContext);
  const value: StickyContextValue = useMemo(
    () => ({ id, parent, container }),
    [container, id, parent]
  );

  return <StickyContext.Provider value={value}>{children}</StickyContext.Provider>;
};
